interface LogoIconProps {
  className?: string;
  variant?: 'primary' | 'white' | 'dark' | 'gradient';
}

export const LogoIcon = ({ className = "w-8 h-8", variant = 'primary' }: LogoIconProps) => {
  const getColors = () => {
    switch (variant) {
      case 'white':
        return { primary: '#FFFFFF', secondary: '#FFFFFF', accent: '#FFFFFF' };
      case 'dark':
        return { primary: '#1a1a1a', secondary: '#4a4a4a', accent: '#dc2626' };
      case 'gradient':
        return { primary: 'url(#logo-gradient)', secondary: 'url(#logo-gradient-2)', accent: 'url(#logo-gradient-accent)' };
      default:
        return { primary: '#dc2626', secondary: '#ef4444', accent: '#f87171' };
    }
  };

  const colors = getColors();

  return (
    <svg
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {variant === 'gradient' && (
        <defs>
          <linearGradient id="logo-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#dc2626" />
            <stop offset="100%" stopColor="#ef4444" />
          </linearGradient>
          <linearGradient id="logo-gradient-2" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#ef4444" />
            <stop offset="100%" stopColor="#f87171" />
          </linearGradient>
          <linearGradient id="logo-gradient-accent" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#f87171" />
            <stop offset="100%" stopColor="#fca5a5" />
          </linearGradient>
        </defs>
      )}
      
      {/* Symmetrical rounded square chat bubble with tail */}
      <path
        d="M25 35 C25 28 30 23 37 23 L83 23 C90 23 95 28 95 35 L95 75 C95 82 90 87 83 87 L50 87 L35 100 L35 87 C29 87 25 82 25 75 Z"
        fill={colors.primary}
        opacity="0.95"
      />
      
      {/* Simple smile - circular arc */}
      <path
        d="M40 58 A 22 22 0 0 0 80 58"
        stroke="white"
        strokeWidth="5"
        strokeLinecap="round"
        fill="none"
        opacity="0.95"
      />
    </svg>
  );
};
